module.exports = __webpack_public_path__ + "images/category_lp/camera/new/assessment_achievements/3@2x_e3f1d88f3d9ce4ad644e4e3b3fc2791d.png";